import { Injectable, Type } from '@angular/core';
import { ResolveGameLineActionModalComponent } from './resolve-game-line-action-modal/resolve-game-line-action-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ActionModalRegistryService {
  private actionModalRegistry: Map<string, Type<any>> = new Map<string, Type<any>>([
    ['ResolveGameLineActionModalComponent', ResolveGameLineActionModalComponent],
  ]);

  constructor() {}

  getActionModalByName(name: string): Type<any> {
    return this.actionModalRegistry.get(name);
  }
}
